import { mixed, object, string } from "yup";

import { YesNo } from "@covertree/types";
import { nonEmptyString } from "@covertree/utils";

import {
  InjuredPeopleFormPart,
  injuredPeopleValidation,
} from "../shared/InjuredPersonsSection/form";

interface FireOrSmokeDamageFormPart {
  claimDescription: string;
  fireResponse: YesNo;
  fireDepartment?: string;
  policeDepartment?: string;
}

export type FireOrSmokeDamageForm = FireOrSmokeDamageFormPart &
  InjuredPeopleFormPart;

export const validation = object({
  claimDescription: nonEmptyString("Claim description").max(
    3000,
    "Claim description is too long"
  ),
  fireResponse: mixed<YesNo>()
    .oneOf(Object.values(YesNo), "Answer to the marked question is required")
    .required(),
  fireDepartment: string().when("fireResponse", ([fireResponse]) =>
    fireResponse === YesNo.Yes
      ? string().max(200, "Fire department is too long").notRequired()
      : string().nullable()
  ),
  policeDepartment: string().when("fireResponse", ([fireResponse]) =>
    fireResponse === YesNo.Yes
      ? string().max(200, "Police department is too long").notRequired()
      : string().nullable()
  ),

  ...injuredPeopleValidation,
});
